'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadStagedThread = loadStagedThread;

var _stubbedThreadId = require('../../threads/constants/stubbedThreadId');

var _selectThread = require('../../selected-thread/actions/selectThread');

var _buildStubbedThread = require('../../threads/factories/buildStubbedThread');

var _addConversation = require('../../actions/ConversationsActions/addConversation');

var _resetStubbedThread = require('../../stubbed-thread-history/actions/resetStubbedThread');

var _updateView = require('../../current-view/actions/updateView');

var _views = require('../../current-view/constants/views');

var _stageInitialMessage = require('../../actions/PublishActions/stageInitialMessage');

var _getMessagesPageUri = require('../../selectors/widgetDataSelectors/getMessagesPageUri');

function loadStagedThread() {
  return function (dispatch, getState) {
    dispatch((0, _selectThread.selectThread)(_stubbedThreadId.STUBBED_THREAD_ID));

    dispatch((0, _resetStubbedThread.resetStubbedThread)());
    dispatch((0, _addConversation.addConversation)((0, _buildStubbedThread.buildStubbedThread)({ currentUrl: (0, _getMessagesPageUri.getMessagesPageUri)(getState()) })));

    dispatch((0, _updateView.updateView)(_views.THREAD_VIEW));

    dispatch((0, _stageInitialMessage.stageInitialMessage)());
  };
}